import React, { FC } from 'react'
import styles from './Svg.module.scss'

type TProps = {
  name: string
  align?: 'left' | 'right'
  styleNames?: string
  height?: string
  width?: string
  onClick?: () => void
  style?: { [key: string]: string }
  rootStyle?: { [key: string]: string }
}

function getCustomSvg(name: any, styleNames: any, iconStyle: any) {
  switch (name) {
    case 'logo':
      return (
        <svg
          className={styles[styleNames]}
          style={iconStyle}
          viewBox="0 0 60 60"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="linearGradient-1">
              <stop stopColor="#FED766" offset="0%" />
              <stop stopColor="#FF0734" offset="34.5624097%" />
              <stop stopColor="#048FF2" offset="65.4308165%" />
              <stop stopColor="#33CC75" offset="100%" />
            </linearGradient>
          </defs>
          <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Robin-/-Ring" transform="translate(-2.000000, -2.000000)" stroke="url(#linearGradient-1)">
              <g id="Robin-Ring" transform="translate(3.000000, 3.000000)">
                <ellipse
                  id="Oval"
                  strokeWidth="4.13337582"
                  transform="translate(29.000000, 29.000000) rotate(360.000000) translate(-29.000000, -29.000000) "
                  cx="29.0026888"
                  cy="29.0009059"
                  rx="26.7205419"
                  ry="26.7187591"
                />
                <ellipse
                  id="Oval"
                  strokeWidth="8.26675163"
                  opacity="0.300000012"
                  transform="translate(29.015459, 29.015459) rotate(360.000000) translate(-29.015459, -29.015459) "
                  cx="29.0178488"
                  cy="29.0231162"
                  rx="25.5869309"
                  ry="25.5921983"
                />
              </g>
            </g>
          </g>
        </svg>
      )
    case 'tick':
      return (
        <svg
          className={styles[styleNames]}
          style={iconStyle}
          viewBox="0 0 14 10"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.900000036">
            <g transform="translate(-5.000000, -7.000000)" fill="#000000" fillRule="nonzero" stroke="#000000">
              <g id="Valid" transform="translate(4.000000, 4.000000)">
                <polygon
                  id="Shape"
                  points="5.87555556 10.5688889 3.11111111 7.80444444 2.16888889 8.74666667 5.87555556 12.4444444 13.8311111 4.48888889 12.8888889 3.55555556"
                />
              </g>
            </g>
          </g>
        </svg>
      )
    case 'loading':
      return (
        <svg
          className={styles[styleNames]}
          style={iconStyle}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
        >
          <circle cx="84" cy="50" r="0.00255203" fill="#ffffff" style={{ opacity: 0.3 }}>
            <animate
              attributeName="r"
              values="10;0;0;0;0"
              keyTimes="0;0.25;0.5;0.75;1"
              keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
              calcMode="spline"
              dur="1.7s"
              repeatCount="indefinite"
              begin="0s"
            />
            <animate
              attributeName="cx"
              values="84;84;84;84;84"
              keyTimes="0;0.25;0.5;0.75;1"
              keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
              calcMode="spline"
              dur="1.7s"
              repeatCount="indefinite"
              begin="0s"
            />
          </circle>
          <circle cx="83.9913" cy="50" r="10" fill="#ffffff" style={{ opacity: 0.9 }}>
            <animate
              attributeName="r"
              values="0;10;10;10;0"
              keyTimes="0;0.25;0.5;0.75;1"
              keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
              calcMode="spline"
              dur="1.7s"
              repeatCount="indefinite"
              begin="-0.85s"
            />
            <animate
              attributeName="cx"
              values="16;16;50;84;84"
              keyTimes="0;0.25;0.5;0.75;1"
              keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
              calcMode="spline"
              dur="1.7s"
              repeatCount="indefinite"
              begin="-0.85s"
            />
          </circle>
          <circle cx="49.9913" cy="50" r="10" fill="#ffffff" style={{ opacity: 0.1 }}>
            <animate
              attributeName="r"
              values="0;10;10;10;0"
              keyTimes="0;0.25;0.5;0.75;1"
              keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
              calcMode="spline"
              dur="1.7s"
              repeatCount="indefinite"
              begin="-0.425s"
            />
            <animate
              attributeName="cx"
              values="16;16;50;84;84"
              keyTimes="0;0.25;0.5;0.75;1"
              keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
              calcMode="spline"
              dur="1.7s"
              repeatCount="indefinite"
              begin="-0.425s"
            />
          </circle>
          <circle cx="16" cy="50" r="9.99745" fill="#ffffff" style={{ opacity: 0.3 }}>
            <animate
              attributeName="r"
              values="0;10;10;10;0"
              keyTimes="0;0.25;0.5;0.75;1"
              keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
              calcMode="spline"
              dur="1.7s"
              repeatCount="indefinite"
              begin="0s"
            />
            <animate
              attributeName="cx"
              values="16;16;50;84;84"
              keyTimes="0;0.25;0.5;0.75;1"
              keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
              calcMode="spline"
              dur="1.7s"
              repeatCount="indefinite"
              begin="0s"
            />
          </circle>
          <circle cx="16" cy="50" r="0" fill="#ffffff" style={{ opacity: 0.9 }}>
            <animate
              attributeName="r"
              values="0;0;10;10;10"
              keyTimes="0;0.25;0.5;0.75;1"
              keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
              calcMode="spline"
              dur="1.7s"
              repeatCount="indefinite"
              begin="0s"
            />
            <animate
              attributeName="cx"
              values="16;16;16;50;84"
              keyTimes="0;0.25;0.5;0.75;1"
              keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
              calcMode="spline"
              dur="1.7s"
              repeatCount="indefinite"
              begin="0s"
            />
          </circle>
        </svg>
      )
    case 'loading-circle':
      return (
        <svg
          className={styles[styleNames]}
          style={iconStyle}
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
        >
          <g transform="rotate(0 50 50)">
            <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#000000">
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin="-0.875s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
          <g transform="rotate(45 50 50)">
            <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#000000">
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin="-0.75s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
          <g transform="rotate(90 50 50)">
            <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#000000">
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin="-0.625s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
          <g transform="rotate(135 50 50)">
            <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#000000">
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin="-0.5s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
          <g transform="rotate(180 50 50)">
            <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#000000">
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin="-0.375s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
          <g transform="rotate(225 50 50)">
            <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#000000">
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin="-0.25s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
          <g transform="rotate(270 50 50)">
            <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#000000">
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin="-0.125s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
          <g transform="rotate(315 50 50)">
            <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#000000">
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin="0s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
        </svg>
      )
    case 'arrow-left':
      return (
        <svg
          className={styles[styleNames]}
          style={iconStyle}
          viewBox="0 0 29 29"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Form-/-Elements-/-Calendar" transform="translate(-24.000000, -17.000000)">
              <g id="Calendar" transform="translate(24.000000, 17.000000)">
                <g id="Left-Arrow">
                  <polygon
                    id="Shape"
                    points="0 0.576989619 28.3290566 0.576989619 28.3290566 28.2724913 0 28.2724913"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
    case 'clear':
      return (
        <svg
          className={styles[styleNames]}
          style={iconStyle}
          viewBox="0 0 20 20"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Form-/-Field-/-Elements-/-Icon-/-Clear" transform="translate(-6.000000, -6.000000)">
              <g id="Clear" transform="translate(6.000000, 6.000000)">
                <path
                  d="M20,10 C20,4.47733333 15.5226667,0 10,0 C4.47733333,0 0,4.47733333 0,10 C0,15.5226667 4.47733333,20 10,20 C15.5226667,20 20,15.5226667 20,10"
                  id="Fill-343"
                  fill="#000000"
                  fillRule="nonzero"
                  opacity="0.5"
                />
                <path
                  d="M6.66666667,6.66666667 L13.3333333,13.3333333"
                  id="Stroke-383"
                  stroke="#FFFFFF"
                  strokeWidth="1.18800002"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M13.3333333,6.66666667 L6.66666667,13.3333333"
                  id="Stroke-385"
                  stroke="#FFFFFF"
                  strokeWidth="1.18800002"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
          </g>
        </svg>
      )

    case 'close':
      return (
        <svg
          className={styles[styleNames]}
          style={iconStyle}
          viewBox="0 0 10 10"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.600000024">
            <g
              id="Form-/-Elements-/-VAT-control"
              transform="translate(-287.000000, -23.000000)"
              fill="#000000"
              fillRule="nonzero"
            >
              <g id="Group" transform="translate(280.000000, 16.000000)">
                <path
                  d="M16.0784184,7.91996777 C15.9184965,7.76001074 15.6585209,7.76001074 15.498599,7.91996777 L11.9991799,11.4201558 L8.4997608,7.91996777 C8.33983891,7.76001074 8.07986331,7.76001074 7.91994142,7.91996777 C7.76001953,8.07992481 7.76001953,8.33995752 7.91994142,8.49991455 L11.4193605,12.0001025 L7.91994142,15.5002905 C7.76001953,15.6602476 7.76001953,15.9202803 7.91994142,16.0802373 C8.00031242,16.160626 8.1052868,16.2 8.21026117,16.2 C8.31523554,16.2 8.42020991,16.1598057 8.50058091,16.0802373 L12,12.5800493 L15.4994191,16.0802373 C15.5797901,16.160626 15.6847645,16.2 15.7897388,16.2 C15.8947132,16.2 15.9996876,16.1598057 16.0800586,16.0802373 C16.2399805,15.9202803 16.2399805,15.6602476 16.0800586,15.5002905 L12.5806395,12.0001025 L16.0800586,8.49991455 C16.2391604,8.33995752 16.2391604,8.07992481 16.0784184,7.91996777 Z"
                  id="Shape"
                />
              </g>
            </g>
          </g>
        </svg>
      )

    case 'info':
      return (
        <svg
          className={styles[styleNames]}
          style={iconStyle}
          viewBox="0 0 18 18"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.5">
            <g transform="translate(-47.000000, -687.000000)">
              <g transform="translate(40.000000, 680.000000)">
                <g transform="translate(6.000000, 6.000000)">
                  <polygon id="Shape" points="0 0 20 0 20 20 0 20" />
                  <path
                    d="M10,1.66666667 C5.4,1.66666667 1.66666667,5.4 1.66666667,10 C1.66666667,14.6 5.4,18.3333333 10,18.3333333 C14.6,18.3333333 18.3333333,14.6 18.3333333,10 C18.3333333,5.4 14.6,1.66666667 10,1.66666667 Z M10.8333333,14.1666667 L9.16666667,14.1666667 L9.16666667,9.16666667 L10.8333333,9.16666667 L10.8333333,14.1666667 Z M10.8333333,7.5 L9.16666667,7.5 L9.16666667,5.83333333 L10.8333333,5.83333333 L10.8333333,7.5 Z"
                    fill="#000000"
                    fillRule="nonzero"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      )

    case 'edit':
      return (
        <svg
          className={styles[styleNames]}
          style={iconStyle}
          viewBox="0 0 14 16"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.900000036">
            <g id="Form-/-Field-/-Elements-/-Icon-/-Edit" transform="translate(-9.000000, -8.000000)" fill="#000000">
              <path
                d="M23,24 L17.2439759,21.8392283 L9,11.7967846 L10.0436747,10.0064309 L10.4337349,9.70803859 L11.4563253,8.90546624 L11.8358434,8.60707395 L13.8599398,8 L22.0301205,17.9498392 L23,24 Z M21.2605422,18.4951768 C21.1621481,18.4608787 21.0848396,18.4437299 21.0286145,18.4437299 C20.6772071,18.4437299 20.3960854,18.6838132 20.185241,19.1639871 C20.0306217,19.1159697 19.914659,19.0919614 19.8373494,19.0919614 C19.5913642,19.0919614 19.3559248,19.198284 19.1310241,19.4109325 C18.9061234,19.6235809 18.7936747,19.8465154 18.7936747,20.0797428 C18.7936747,20.1346198 18.7971887,20.2066448 18.8042169,20.2958199 C18.2208806,20.4124336 17.9292169,20.7211122 17.9292169,21.221865 L19.5527108,21.7672026 C19.9111464,20.820574 20.5612403,20.3129693 21.503012,20.244373 L21.2605422,18.4951768 Z M20.6912651,17.8572347 L13.3539157,8.91575563 L12.4472892,9.19356913 L19.9533133,18.340836 C20.1290169,18.0664509 20.3749984,17.9052521 20.6912651,17.8572347 Z M19.2891566,18.6083601 L11.878012,9.58456592 L11.0135542,10.2636656 L18.435241,19.3080386 C18.6039165,18.9307591 18.8885522,18.6975353 19.2891566,18.6083601 Z M18.0346386,19.8945338 L10.496988,10.7163987 L10.0225904,11.5189711 L17.4126506,20.5221865 C17.4829321,20.2340822 17.6902593,20.0248667 18.0346386,19.8945338 Z"
                id="✎"
                transform="translate(16.000000, 16.000000) scale(-1, 1) translate(-16.000000, -16.000000)"
              />
            </g>
          </g>
        </svg>
      )

    case 'trash':
      return (
        <svg
          className={styles[styleNames]}
          style={iconStyle}
          viewBox="0 0 14 18"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
              id="Form-/-Field-/-Elements-/-Icon-/-Trash"
              transform="translate(-9.000000, -7.000000)"
              fill="#ED7161"
              fillRule="nonzero"
            >
              <g id="Office-Garbidge-Can-Trash-Bin-Recycle-2" transform="translate(9.000000, 7.000000)">
                <path
                  d="M12.4444444,2.25 L10.1111111,2.25 L10.1111111,1.5 C10.1111111,0.6727275 9.41308589,0 8.55555556,0 L5.44444444,0 C4.58691333,0 3.88888889,0.67272975 3.88888889,1.5 L3.88888889,2.25 L1.55555556,2.25 C0.698024444,2.25 0,2.92272975 0,3.75 L0,4.875 C0,5.08227525 0.173936778,5.25 0.388888889,5.25 L13.6111111,5.25 C13.8260632,5.25 14,5.08227525 14,4.875 L14,3.75 C14,2.9227275 13.3019748,2.25 12.4444444,2.25 Z M5.44444444,1.5 L8.55555556,1.5 L8.55555556,2.25 L5.44444444,2.25 L5.44444444,1.5 Z"
                  id="Shape"
                />
                <path
                  d="M12.8333333,6 L1.16666667,6 C0.951714556,6 0.777777778,6.16772475 0.777777778,6.375 L0.777777778,16.5 C0.777777778,17.3272725 1.475803,18 2.33333333,18 L11.6666667,18 C12.5241978,18 13.2222222,17.3272703 13.2222222,16.5 L13.2222222,6.375 C13.2222222,6.16772475 13.0482854,6 12.8333333,6 Z"
                  id="Shape"
                />
              </g>
            </g>
          </g>
        </svg>
      )

    case 'add':
      return (
        <svg
          className={styles[styleNames]}
          style={iconStyle}
          viewBox="0 0 14 14"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.900000036">
            <g
              id="Form-/-Field-/-Elements-/-Icon-/-Add-(on)"
              transform="translate(-9.000000, -9.000000)"
              fill="#000000"
            >
              <path
                d="M22,15 L17,15 L17,10 C17,8.67746754 15,8.67746754 15,10 L15,15 L10,15 C8.67746754,15 8.67746754,17 10,17 L15,17 L15,22 C15,23.3225325 17,23.3225325 17,22 L17,17 L22,17 C23.3225325,17 23.3225325,15 22,15 Z"
                id="Path"
              />
            </g>
          </g>
        </svg>
      )

    case 'calendar':
      return (
        <svg
          className={styles[styleNames]}
          style={iconStyle}
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.900000036">
            <g
              id="Form-/-Field-/-Elements-/-Icon-/-Calendar-(on)"
              transform="translate(-5.000000, -4.000000)"
              fill="#000000"
              fillRule="nonzero"
            >
              <g id="Time-Event-Calendar-Settings" transform="translate(5.000000, 4.000000)">
                <path
                  d="M23.6216,17.0151 L22.663592,16.775354 L23.171404,15.928674 C23.289568,15.731897 23.2583181,15.479944 23.0962087,15.317834 L22.0000187,14.221644 L22.0000187,3.999944 C22.0000187,2.896914 21.1030457,1.999944 20.0000187,1.999944 L17.5000187,1.999944 C17.2236517,1.999944 17.0000187,2.223577 17.0000187,2.499944 L17.0000187,4.999944 C17.0000187,5.551214 16.5512887,5.999944 16.0000187,5.999944 C15.4487487,5.999944 15.0000187,5.551214 15.0000187,4.999944 C15.0000187,4.581975 15.2685737,4.20551 15.6679877,4.063421 C15.8672067,3.9921319 16.0000187,3.803655 16.0000187,3.59223 L16.0000187,0.49994 C16.0000187,0.223573 15.7763857,-6e-05 15.5000187,-6e-05 C15.2236517,-6e-05 15.0000187,0.223573 15.0000187,0.49994 L15.0000187,1.99994 L7.5000187,1.99994 C7.2236517,1.99994 7.0000187,2.223573 7.0000187,2.49994 L7.0000187,4.99994 C7.0000187,5.55121 6.5512887,5.99994 6.0000187,5.99994 C5.4487487,5.99994 5.0000187,5.55121 5.0000187,4.99994 C5.0000187,4.581971 5.2685737,4.205506 5.6679877,4.063417 C5.8672067,3.9921279 6.0000187,3.803651 6.0000187,3.592226 L6.0000187,0.499936 C6.0000187,0.223569 5.7763857,-6.4e-05 5.5000187,-6.4e-05 C5.2236517,-6.4e-05 5.0000187,0.223569 5.0000187,0.499936 L5.0000187,1.999936 L2.0000187,1.999936 C0.8969887,1.999936 1.87e-05,2.896909 1.87e-05,3.999936 L1.87e-05,19.999936 C1.87e-05,21.102966 0.8969917,21.999936 2.0000187,21.999936 L14.2217187,21.999936 L15.3179087,23.096126 C15.4795297,23.257259 15.7309947,23.288997 15.9287487,23.1713213 L16.7754287,22.6635093 L17.0151747,23.6215173 C17.0708388,23.8436853 17.2705457,23.9999353 17.5000377,23.9999353 L19.5000377,23.9999353 C19.7295297,23.9999353 19.9292367,23.8436853 19.9849007,23.6215173 L20.2246467,22.6635093 L21.0713267,23.1713213 C21.2681037,23.2894853 21.5200567,23.2582354 21.6821667,23.096126 L23.0962267,21.682066 C23.2583357,21.519957 23.2895857,21.268004 23.171422,21.071226 L22.66361,20.224546 L23.621618,19.9848 C23.843786,19.9291359 24.000036,19.729429 24.000036,19.499937 L24.000036,17.499937 C24.000036,17.270445 23.843786,17.070738 23.621618,17.015074 L23.6216,17.0151 Z M15.31789,13.90377 L13.90383,15.31783 C13.741721,15.479939 13.710471,15.731892 13.8286347,15.92867 L14.3364467,16.77535 L13.3784387,17.015096 C13.1562707,17.0707601 13.0000207,17.270467 13.0000207,17.499959 L13.0000207,19.499959 C13.0000207,19.729451 13.1562707,19.929158 13.3784387,19.984822 L13.4389245,19.9999587 L2.0000245,19.9999587 L2.0000245,7.9999587 L20.0000245,7.9999587 L20.0000245,13.4388587 L19.9848878,13.3783729 C19.9292237,13.1562049 19.7295168,12.9999549 19.5000248,12.9999549 L17.5000248,12.9999549 C17.2705328,12.9999549 17.0708258,13.1562049 17.0151618,13.3783729 L16.7754158,14.3363809 L15.9287358,13.8285689 C15.7314698,13.7108929 15.4795168,13.7411665 15.3178958,13.9037642 L15.31789,13.90377 Z M18.50002,20.99996 C17.1216,20.99996 16.00002,19.87838 16.00002,18.49996 C16.00002,17.12154 17.1216,15.99996 18.50002,15.99996 C19.87844,15.99996 21.00002,17.12154 21.00002,18.49996 C21.00002,19.87838 19.87844,20.99996 18.50002,20.99996 Z"
                  id="Shape"
                />
              </g>
            </g>
          </g>
        </svg>
      )

    case 'options':
      return (
        <svg
          className={styles[styleNames]}
          width="4px"
          height="14px"
          viewBox="0 0 4 14"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-702.000000, -37.000000)">
              <g transform="translate(688.000000, 28.000000)">
                <rect fill="#000000" opacity="0" x="0" y="0" width="32" height="32" rx="4" />
                <g opacity="0.5" strokeWidth="1" transform="translate(7.000000, 7.000000)">
                  <polygon points="0 0 18 0 18 18 0 18" />
                  <path
                    d="M9,5.5 C9.83,5.5 10.5,4.83 10.5,4 C10.5,3.17 9.83,2.5 9,2.5 C8.17,2.5 7.5,3.17 7.5,4 C7.5,4.83 8.17,5.5 9,5.5 Z M9,7.5 C8.17,7.5 7.5,8.17 7.5,9 C7.5,9.83 8.17,10.5 9,10.5 C9.83,10.5 10.5,9.83 10.5,9 C10.5,8.17 9.83,7.5 9,7.5 Z M9,12.5 C8.17,12.5 7.5,13.17 7.5,14 C7.5,14.83 8.17,15.5 9,15.5 C9.83,15.5 10.5,14.83 10.5,14 C10.5,13.17 9.83,12.5 9,12.5 Z"
                    id="Shape"
                    fill="#000000"
                    fillRule="nonzero"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      )

    case 'otp-shield':
      return (
        <svg width="26px" height="34px" viewBox="0 0 26 34" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient x1="0%" y1="6.123234e-15%" x2="100%" y2="100%" id="linearGradient-1">
              <stop stopColor="#FED766" offset="0%" />
              <stop stopColor="#FF0734" offset="35.3910766%" />
              <stop stopColor="#048FF2" offset="68.3842124%" />
              <stop stopColor="#33CC75" offset="100%" />
            </linearGradient>
          </defs>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" fillOpacity="0.5" strokeOpacity="0.6">
            <g
              transform="translate(-50.000000, -599.000000)"
              fill="url(#linearGradient-1)"
              stroke="#000000"
              strokeWidth="1.5"
            >
              <path
                d="M63,632 C75,626.20288 75,621.333333 75,612.444444 L75,603.555556 L63,600 L51,603.555556 L51,612.444444 C51,621.333333 51,626.20288 63,632 Z"
                id="Shape"
              />
            </g>
          </g>
        </svg>
      )

    case 'otp-shield-and-ring':
      return (
        <svg width="146px" height="120px" viewBox="0 0 146 120" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="linearGradient-1">
              <stop stopColor="#FED766" offset="0%" />
              <stop stopColor="#FF0734" offset="34.5624097%" />
              <stop stopColor="#048FF2" offset="65.4308165%" />
              <stop stopColor="#33CC75" offset="100%" />
            </linearGradient>
            <rect id="path-2" x="2" y="2" width="44" height="76" />
            <filter x="-218.2%" y="-93.4%" width="536.4%" height="352.6%" filterUnits="objectBoundingBox" id="filter-3">
              <feMorphology radius="1" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1" />
              <feOffset dx="0" dy="5" in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
              <feGaussianBlur stdDeviation="5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
              <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
              <feColorMatrix
                values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
                type="matrix"
                in="shadowBlurOuter1"
                result="shadowMatrixOuter1"
              />
              <feMorphology radius="6" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter2" />
              <feOffset dx="0" dy="20" in="shadowSpreadOuter2" result="shadowOffsetOuter2" />
              <feGaussianBlur stdDeviation="20" in="shadowOffsetOuter2" result="shadowBlurOuter2" />
              <feComposite in="shadowBlurOuter2" in2="SourceAlpha" operator="out" result="shadowBlurOuter2" />
              <feColorMatrix
                values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
                type="matrix"
                in="shadowBlurOuter2"
                result="shadowMatrixOuter2"
              />
              <feMerge>
                <feMergeNode in="shadowMatrixOuter1" />
                <feMergeNode in="shadowMatrixOuter2" />
              </feMerge>
            </filter>
            <linearGradient x1="0%" y1="6.123234e-15%" x2="100%" y2="100%" id="linearGradient-4">
              <stop stopColor="#FED766" offset="0%" />
              <stop stopColor="#FF0734" offset="35.3910766%" />
              <stop stopColor="#048FF2" offset="68.3842124%" />
              <stop stopColor="#33CC75" offset="100%" />
            </linearGradient>
          </defs>
          <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Robin-/-Secure-/-OTP-Modal" transform="translate(-107.000000, -34.000000)">
              <g id="Robin-Secure" transform="translate(120.000000, 32.000000)">
                <rect id="Rectangle-5" fill="#BD10E0" opacity="0" x="0" y="0" width="120" height="120" />
                <g id="Group-4" transform="translate(4.000000, 4.000000)">
                  <g id="Group-2">
                    <g id="Robin-/-Ring" stroke="url(#linearGradient-1)">
                      <g id="Robin-Ring" transform="translate(5.208805, 5.208805)">
                        <ellipse
                          id="Oval"
                          strokeWidth="7.1766497"
                          transform="translate(50.351783, 50.351783) rotate(360.000000) translate(-50.351783, -50.351783) "
                          cx="50.3564512"
                          cy="50.3533557"
                          rx="46.3940318"
                          ry="46.3909363"
                        />
                        <ellipse
                          id="Oval"
                          strokeWidth="14.3532994"
                          opacity="0.300000012"
                          transform="translate(50.378624, 50.378624) rotate(360.000000) translate(-50.378624, -50.378624) "
                          cx="50.3827731"
                          cy="50.3919186"
                          rx="44.4257789"
                          ry="44.4349244"
                        />
                      </g>
                    </g>
                    <g id="Group" transform="translate(32.000000, 27.000000)">
                      <g id="Rectangle-4">
                        <use fill="black" fillOpacity="1" filter="url(#filter-3)" xlinkHref="#path-2" />
                        <rect
                          strokeOpacity="0.1"
                          stroke="#838383"
                          strokeWidth="1"
                          fillOpacity="0.599999964"
                          fill="#000000"
                          fillRule="evenodd"
                          x="1.5"
                          y="1.5"
                          width="45"
                          height="77"
                        />
                      </g>
                      <path
                        d="M4.00000006,0 L43.9999999,0 C46.209139,-4.05812257e-16 48,1.79086103 48,4.00000006 L48,75.9999999 C48,78.209139 46.209139,80 43.9999999,80 L4.00000006,80 C1.79086103,80 2.70541504e-16,78.209139 0,75.9999999 L0,4.00000006 C-2.70541504e-16,1.79086103 1.79086103,4.05812257e-16 4.00000006,0 Z M5.60000004,3.2 C4.27451662,3.2 3.2,4.27451662 3.2,5.60000004 L3.2,74.4 C3.2,75.7254834 4.27451662,76.8 5.60000004,76.8 L42.4,76.8 C43.7254834,76.8 44.8,75.7254834 44.8,74.4 L44.8,5.60000004 C44.8,4.27451662 43.7254834,3.2 42.4,3.2 L5.60000004,3.2 Z M20.8,67.2 L27.2,67.2 C28.0836556,67.2 28.8,67.9163444 28.8,68.8 C28.8,69.6836556 28.0836556,70.4 27.2,70.4 L20.8,70.4 C19.9163444,70.4 19.2,69.6836556 19.2,68.8 C19.2,67.9163444 19.9163444,67.2 20.8,67.2 Z"
                        id="Combined-Shape"
                        fill="#FFFFFF"
                      />
                    </g>
                  </g>
                  <path
                    d="M56.1,67 C65.2,62.65216 65.2,59 65.2,52.3333333 L65.2,45.6666667 L56.1,43 L47,45.6666667 L47,52.3333333 C47,59 47,62.65216 56.1,67 Z"
                    id="Shape"
                    stroke="#FFFFFF"
                    strokeWidth="2"
                    fillOpacity="0.800000012"
                    fill="url(#linearGradient-4)"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      )

    case 'onboarding-verify':
      return (
        <svg style={iconStyle} width="85px" height="93px" viewBox="0 0 85 93" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="linearGradient-1">
              <stop stopColor="#FED766" offset="0%" />
              <stop stopColor="#FF0734" offset="35.3910766%" />
              <stop stopColor="#048FF2" offset="68.3842124%" />
              <stop stopColor="#33CC75" offset="100%" />
            </linearGradient>
          </defs>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-78.000000, -49.000000)">
              <g>
                <rect id="Rectangle-11" fill="#BD10E0" opacity="0" x="0" y="0" width="240" height="192" />
                <g opacity="0.900000036" transform="translate(78.400000, 49.600000)" fillRule="nonzero">
                  <path
                    d="M68,4 L68,32 C68,48.9748 47.2512,76 30,76 C24.429081,75.6512413 19.103921,73.5812761 14.760001,70.0760001 C22.302801,80.0468001 32.652401,88.0000001 42.000001,88.0000001 C59.251201,88.0000001 80.000001,60.9748001 80.000001,44.0000001 L80.000001,4 L68,4 Z"
                    id="Shape"
                    fill="url(#linearGradient-1)"
                    opacity="0.149999991"
                  />
                  <path
                    d="M0,0 L0,44 C0,62.5 21.75,92 42,92 C62.25,92 84,62.5 84,44 L84,0 L0,0 Z M80,44 C80,60.9748 59.2512,88 42,88 C24.7488,88 4,60.9748 4,44 L4,4 L80,4 L80,44 Z"
                    id="Shape"
                    fill="#000000"
                  />
                  <path
                    d="M42,80 C43.1045679,80 43.9999999,79.104568 43.9999999,78 C44,76.895432 43.1045679,76 41.9999999,76 C30.1971999,76 15.9999999,57.5744 15.9999999,46 L15.9999999,16 L33.9999999,16 C35.1045678,16 35.9999998,15.104568 35.9999998,14 C35.9999999,12.895432 35.1045678,12 33.9999998,12 L13.9999998,12 C12.8954317,12 11.9999997,12.895432 11.9999997,14 C11.9999997,14 11.9999997,14 11.9999997,14 L11.9999997,46 C11.9999997,59.7344 27.8027997,80 41.9999997,80 L42,80 Z"
                    id="Shape"
                    fill="#000000"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      )

    case 'onboarding-business':
      return (
        <svg style={iconStyle} width="96px" height="92px" viewBox="0 0 96 92" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="linearGradient-1">
              <stop stopColor="#FED766" offset="0%" />
              <stop stopColor="#FF0734" offset="35.3910766%" />
              <stop stopColor="#048FF2" offset="68.3842124%" />
              <stop stopColor="#33CC75" offset="100%" />
            </linearGradient>
          </defs>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-72.000000, -50.000000)">
              <g>
                <rect fill="#BD10E0" opacity="0" x="0" y="0" width="240" height="192" />
                <g opacity="0.900000036" transform="translate(72.000000, 50.000000)" fillRule="nonzero">
                  <path
                    d="M90,4 L84,4 L84,78 L84,77.9999964 C83.9986795,79.1040164 83.104024,79.9986764 82.000004,80.0000004 L28.000004,80.0000004 L28.000004,86.0000004 L28.000004,85.9999968 C28.0013245,87.1040168 28.89598,87.9986768 30,88.0000008 L90,88.0000008 C91.1040201,87.9986783 91.9986761,87.1040208 92.0000001,86.0000008 L92.0000001,6.00000081 L92.0000001,6.00000442 C91.9986796,4.89598442 91.1040281,4.00132842 90.0000081,4.00000042 L90,4 Z"
                    id="Shape"
                    fill="url(#linearGradient-1)"
                    opacity="0.149999991"
                  />
                  <path
                    d="M90,0 L30,0 L29.9999997,0 C26.6862917,1.448468e-07 23.9999997,2.686292 23.9999997,6 C23.9999997,6 23.9999997,6 23.9999997,6 L23.9999997,86 L23.9999997,86.0000006 C24.0000002,89.3137086 26.6862917,92.0000006 29.9999997,92.0000006 L89.9999997,92.0000006 L89.9999995,92.0000006 C93.3137075,92.0000004 95.9999995,89.3137086 95.9999995,86.0000006 L95.9999995,6.00000064 C95.9999995,2.68629264 93.3137075,6.43708006e-07 89.9999995,6.43708006e-07 L90,0 Z M92,86 L92,85.9999964 C91.9986795,87.1040164 91.104024,87.9986764 90.000004,88.0000004 L30.000004,88.0000004 C28.895984,87.9986779 28.001328,87.1040204 28.000004,86.0000004 L28.000004,6.00000039 L28.000004,6.00000396 C28.0013244,4.89598396 28.89598,4.00132396 30,3.99999996 L90,3.99999996 C91.1040201,4.00132246 91.9986761,4.89597996 92.0000001,5.99999996 L92,86 Z"
                    id="Shape"
                    fill="#000000"
                  />
                  <g fill="#000000">
                    <path
                      d="M82,24 L58,24 C56.8954319,24 55.9999999,24.895432 55.9999999,26 C56,27.104568 56.8954319,28 57.9999999,28 L81.9999999,28 C83.1045678,28 83.9999998,27.104568 83.9999998,26 C83.9999999,24.895432 83.1045678,24 81.9999998,24 L82,24 Z"
                      id="Shape"
                    />
                    <path
                      d="M48.586,20.586 L42,27.172 L39.414,24.586 C38.619496,23.818644 37.353356,23.840648 36.586,24.6351528 C35.837436,25.4102008 35.837436,26.6389528 36.586,27.4140008 L40.586,31.4140008 L40.5859999,31.4140007 C41.3669999,32.1947647 42.6329999,32.1947647 43.4139999,31.4140009 L51.4139999,23.4140009 C52.2085039,22.6466449 52.2305119,21.3805049 51.4631527,20.5860009 C50.6957967,19.7914969 49.4296567,19.7694889 48.6351527,20.5368481 C48.6184849,20.5529464 48.6020982,20.5693332 48.5859999,20.5860009 L48.586,20.586 Z"
                      id="Shape"
                    />
                    <path
                      d="M82,44 L58,44 C56.8954319,44 55.9999999,44.895432 55.9999999,46 C56,47.104568 56.8954319,48 57.9999999,48 L81.9999999,48 C83.1045678,48 83.9999998,47.104568 83.9999998,46 C83.9999999,44.895432 83.1045678,44 81.9999998,44 L82,44 Z"
                      id="Shape"
                    />
                    <path
                      d="M48.586,40.586 L42,47.172 L39.414,44.586 C38.619496,43.818644 37.353356,43.840648 36.586,44.6351528 C35.837436,45.4102008 35.837436,46.6389528 36.586,47.4140008 L40.586,51.4140008 L40.5859999,51.4140007 C41.3669999,52.1947647 42.6329999,52.1947647 43.4139999,51.4140009 L51.4139999,43.4140009 C52.1813559,42.6194969 52.1593519,41.3533569 51.3648471,40.5860009 C50.5897991,39.8374369 49.3610471,39.8374369 48.5859991,40.586001 L48.586,40.586 Z"
                      id="Shape"
                    />
                    <path
                      d="M82,64 L58,64 C56.8954319,64 55.9999999,64.895432 55.9999999,66 C56,67.104568 56.8954319,68 57.9999999,68 L81.9999999,68 C83.1045678,68 83.9999998,67.104568 83.9999998,66 C83.9999999,64.895432 83.1045678,64 81.9999998,64 L82,64 Z"
                      id="Shape"
                    />
                    <path
                      d="M48.586,60.586 L42,67.172 L39.414,64.586 C38.619496,63.818644 37.353356,63.840648 36.586,64.6351528 C35.837436,65.4102008 35.837436,66.6389528 36.586,67.4140008 L40.586,71.4140008 L40.5859999,71.4140007 C41.3669999,72.1947647 42.6329999,72.1947647 43.4139999,71.4140009 L51.4139999,63.4140009 C52.1813559,62.6194969 52.1593519,61.3533569 51.3648471,60.5860009 C50.5897991,59.8374369 49.3610471,59.8374369 48.5859991,60.586001 L48.586,60.586 Z"
                      id="Shape"
                    />
                    <path
                      d="M10,0 L6,0 L5.99999974,0 C2.68629174,1.448468e-07 -2.62268401e-07,2.686292 -2.62268401e-07,6 C-2.62268401e-07,6 -2.62268401e-07,6 -2.62268401e-07,6 L-2.62268401e-07,86 L-2.6226834e-07,86.0000006 C2.3808766e-07,89.3137086 2.68629174,92.0000006 5.99999974,92.0000006 L9.99999974,92.0000006 L9.99999955,92.0000006 C13.3137075,92.0000004 15.9999995,89.3137086 15.9999995,86.0000006 L15.9999995,6.00000064 C15.9999995,2.68629264 13.3137075,6.43708006e-07 9.99999955,6.43708006e-07 L10,0 Z M12,86 L12,85.9999964 C11.9986795,87.1040164 11.104024,87.9986764 10.000004,88.0000004 L6.000004,88.0000004 C4.89598398,87.9986779 4.00132798,87.1040204 4.00000398,86.0000004 L4.00000398,20.0000004 L12.000004,20.0000004 L12,86 Z M12,16 L4,16 L4,6 L4,6.00000358 C4.00132047,4.89598358 4.895976,4.00132358 5.999996,3.99999958 L9.999996,3.99999958 C11.1040161,4.00132207 11.9986721,4.89597958 11.9999961,5.99999958 L12,16 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )

    case 'onboarding-theme':
      return (
        <svg style={iconStyle} width="100px" height="92px" viewBox="0 0 100 92" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="linearGradient-1">
              <stop stopColor="#FED766" offset="0%" />
              <stop stopColor="#FF0734" offset="35.3910766%" />
              <stop stopColor="#048FF2" offset="68.3842124%" />
              <stop stopColor="#33CC75" offset="100%" />
            </linearGradient>
          </defs>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-70.000000, -50.000000)">
              <g id="Group-10">
                <rect fill="#BD10E0" opacity="0" x="0" y="0" width="240" height="192" />
                <g opacity="0.900000036" transform="translate(70.000000, 50.000000)" fillRule="nonzero">
                  <polygon fill="url(#linearGradient-1)" opacity="0.149999991" points="24 24 76 24 76 68 24 68" />
                  <path
                    d="M94,0 L6,0 L5.99999974,0 C2.68629174,1.448468e-07 -2.62268401e-07,2.686292 -2.62268401e-07,6 C-2.62268401e-07,6 -2.62268401e-07,6 -2.62268401e-07,6 L-2.62268401e-07,86 L-2.6226833e-07,86.0000006 C2.3808767e-07,89.3137086 2.68629174,92.0000006 5.99999974,92.0000006 L93.9999997,92.0000006 L93.9999995,92.0000006 C97.3137075,92.0000004 99.9999995,89.3137086 99.9999995,86.0000006 L99.9999995,6.00000064 C99.9999995,2.68629264 97.3137075,6.4370802e-07 93.9999995,6.4370802e-07 L94,0 Z M96,86 C96,87.104568 95.104568,88 94,88 L6,88 C4.89543191,88 3.99999991,87.104568 3.99999991,86 C3.99999991,86 3.99999991,86 3.99999991,86 L3.99999991,6 L3.99999991,6.0000003 C3.99999975,4.8954323 4.89543191,4.0000003 5.99999991,4.0000003 L93.9999999,4.0000003 C95.1045678,4.00000025 95.9999998,4.8954323 95.9999998,6.0000003 L96,86 Z"
                    id="Shape"
                    fill="#000000"
                  />
                  <g transform="translate(12.000000, 12.000000)" fill="#000000">
                    <path
                      d="M30.8284,21.17156 C32.390496,22.733656 32.390496,25.26632 30.8284,26.8284 C29.266304,28.390496 26.73364,28.390496 25.17156,26.8284 C23.609464,25.266304 23.609464,22.73364 25.17156,21.17156 C26.733656,19.609464 29.26632,19.609464 30.8284,21.17156"
                      id="Shape"
                    />
                    <path
                      d="M50.8284,21.17156 C52.390496,22.733656 52.390496,25.26632 50.8284,26.8284 C49.266304,28.390496 46.73364,28.390496 45.17156,26.8284 C43.609464,25.266304 43.609464,22.73364 45.17156,21.17156 C46.733656,19.609464 49.26632,19.609464 50.8284,21.17156"
                      id="Shape"
                    />
                    <path
                      d="M46.5956,40.9728 L46.5956004,40.9727997 C41.5768004,45.0119197 34.4228004,45.0119197 29.4040004,40.9728003 C28.6505444,40.1651003 27.3849804,40.1211283 26.5772804,40.8745827 C25.7695804,41.6280387 25.7256084,42.8936027 26.4790628,43.7013027 C26.5163211,43.7412434 26.5552,43.7796411 26.5956016,43.8163991 L26.5956014,43.816399 C29.7172614,46.626215 33.8018814,48.124599 38.0000014,47.999999 L38.0000011,47.999999 C42.1981211,48.1246194 46.2827611,46.626215 49.4044011,43.816399 C50.2214211,43.073063 50.2811571,41.808143 49.5378187,40.991119 C48.7944827,40.174099 47.5295627,40.114363 46.7125387,40.8577014 C46.6721371,40.8944593 46.6332583,40.932857 46.5959999,40.9727978 L46.5956,40.9728 Z"
                      id="Shape"
                    />
                    <path
                      d="M74,48 C72.8954319,48 71.9999999,48.895432 71.9999999,50 C71.9999999,50 71.9999999,50 71.9999999,50 L71.9999999,64 L57.9999999,64 C56.8954318,64 55.9999998,64.895432 55.9999998,66 C55.9999999,67.104568 56.8954318,68 57.9999998,68 L73.9999998,68 C75.1045677,68 75.9999997,67.104568 75.9999997,66 L75.9999997,50 C75.9999997,48.8954319 75.1045677,47.9999999 73.9999997,47.9999999 C73.9999997,47.9999999 73.9999996,47.9999999 73.9999996,47.9999999 L74,48 Z"
                      id="Shape"
                    />
                    <path
                      d="M18,64 L4,64 L4,50 C4,48.895432 3.104568,48 2,48 C0.895432,48 0,48.895432 0,50 L0,66 L2.13162821e-14,66.0000003 C1.66785222e-07,67.1045683 0.895432,68.0000003 2,68.0000003 L18,68.0000003 C19.1045679,68.0000004 19.9999999,67.1045683 19.9999999,66.0000003 C20,64.8954323 19.1045679,64.0000003 17.9999999,64.0000003 L18,64 Z"
                      id="Shape"
                    />
                    <path
                      d="M74,0 L58,0 C56.8954319,4.82824021e-08 55.9999999,0.895432 55.9999999,2 C56,3.104568 56.8954319,4 57.9999999,4 L71.9999999,4 L71.9999999,18 L71.9999999,18.0000003 C72.0000001,19.1045683 72.8954319,20.0000003 73.9999999,20.0000003 C75.1045679,20.0000001 75.9999999,19.1045683 75.9999999,18.0000003 L75.9999999,2.0000003 L75.9999999,2.0000006 C75.9999999,0.895432604 75.1045679,6.03983199e-07 73.9999999,6.03983199e-07 L74,0 Z"
                      id="Shape"
                    />
                    <path
                      d="M18,0 L2,0 C0.895431913,4.82824021e-08 -8.74227997e-08,0.895432 -8.74227997e-08,2 C-8.74227997e-08,2 -8.74227997e-08,2 -8.74227997e-08,2 L-8.74227997e-08,18 L-8.74227783e-08,18.0000002 C7.93624224e-08,19.1045682 0.895431913,20.0000002 1.99999991,20.0000002 C3.10456791,20.0000001 3.99999991,19.1045682 3.99999991,18.0000002 L3.99999991,4.00000024 L17.9999999,4.00000024 C19.1045678,4.00000029 19.9999998,3.10456824 19.9999998,2.00000024 C19.9999999,0.895432242 19.1045678,2.42386793e-07 17.9999998,2.42386793e-07 L18,0 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )

    case 'onboarding-invite':
      return (
        <svg style={iconStyle} width="110px" height="88px" viewBox="0 0 110 88" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="linearGradient-1">
              <stop stopColor="#FED766" offset="0%" />
              <stop stopColor="#FF0734" offset="35.3910766%" />
              <stop stopColor="#048FF2" offset="68.3842124%" />
              <stop stopColor="#33CC75" offset="100%" />
            </linearGradient>
          </defs>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-65.000000, -52.000000)">
              <g>
                <rect fill="#BD10E0" opacity="0" x="0" y="0" width="240" height="192" />
                <g
                  id="User-Plus-B"
                  opacity="0.900000036"
                  transform="translate(65.000000, 52.000000)"
                  fillRule="nonzero"
                >
                  <g transform="translate(39.600000, 4.400000)" fill="url(#linearGradient-1)" opacity="0.149999991">
                    <path
                      d="M6.6,0 C4.36510359,0.00641924803 2.14262399,0.3323848 -1.18901229e-08,0.968 C8.43083999,3.40208 13.2,10.714 13.2,22 C13.2,34.57696 7.44699999,46.244 -1.18901229e-08,50.77864 L4.32259076e-07,50.7786403 C1.97106843,52.0491007 4.25552643,52.7487535 6.60000043,52.8000003 C16.9628804,52.8000003 26.4000004,38.1198403 26.4000004,22.0000003 C26.4000011,8.01900029 19.1840004,2.86310896e-07 6.60000043,2.86310896e-07 L6.6,0 Z"
                      id="Shape"
                    />
                    <path
                      d="M47.24104,68.04116 C31.41952,59.74276 21.41304,55.03564 17.15076,53.43316 L17.1507595,53.4331604 C15.3048231,54.8115968 13.2283795,55.8506392 11.0184795,56.5017204 C16.3899995,59.0004804 24.0490795,62.8016404 34.0414795,68.0424804 L34.0414797,68.0424805 C34.7583761,68.42143 35.2050641,69.1676001 35.2004397,69.9784805 L35.2004397,73.1152405 L35.2004398,73.1152422 C35.2173155,74.4266226 34.255487,75.545547 32.9564398,75.7257622 C25.1684398,76.8108022 11.6665998,78.4946822 0.000439758336,79.0218022 C2.28271976,79.1247622 4.51791976,79.1978022 6.60043976,79.1978022 L6.60045571,79.1978017 C19.8437077,78.8361538 33.0530797,77.6753753 46.1564557,75.7218017 C47.455503,75.5415887 48.4173342,74.4226621 48.4004558,73.1112817 L48.4004558,69.9745217 C48.4040045,69.1644904 47.9572702,68.4195484 47.2410426,68.0411616 L47.24104,68.04116 Z"
                      id="Shape"
                    />
                  </g>
                  <path
                    d="M107.8,35.2 L96.8,35.2 L96.8,24.2 C96.8,22.9849752 95.8150248,22 94.6,22 C93.3849752,22 92.4,22.9849752 92.4,24.2 L92.4,35.2 L81.4,35.2 C80.1849751,35.2000001 79.1999999,36.1849752 79.1999999,37.4 C79.2,38.6150248 80.1849751,39.6 81.3999999,39.6 L92.3999999,39.6 L92.3999999,50.6 L92.3999999,50.6000003 C92.4000001,51.8150251 93.3849751,52.8000003 94.5999999,52.8000003 C95.8150247,52.8000001 96.7999999,51.8150251 96.7999999,50.6000003 L96.7999999,39.6000003 L107.8,39.6000003 C109.015025,39.6000004 110,38.6150251 110,37.4000003 C110,36.1849755 109.015025,35.2000003 107.8,35.2000003 L107.8,35.2 Z"
                    id="Shape"
                    fill="#000000"
                  />
                  <path
                    d="M88.88528,68.54496 C82.33324,65.10856 68.30296,57.86836 60.35788,54.56176 C66.99176,46.6926239 70.55818,36.6910719 70.4,26.3999999 C70.4,8.17475994 59.56544,-5.64449832e-08 46.2,-5.64449832e-08 C32.83456,-5.64449832e-08 22,8.17475994 22,26.3999999 L21.9999991,26.4000592 C21.8430912,36.6773152 25.3994039,46.6661072 32.0157631,54.5318992 C24.0305991,57.8221752 10.0284791,65.0892152 3.49799914,68.5392552 L3.49799931,68.5392551 C1.34001931,69.6802015 -0.00717708634,71.9238319 -6.8634365e-07,74.3648551 L-6.8634365e-07,77.5156951 L-6.8381273e-07,77.5156943 C-0.0116097318,81.0210511 2.56678332,83.9966303 6.03811932,84.4839743 L6.03810327,84.4839719 C19.3424713,86.4628851 32.7541553,87.6370339 46.1999833,88.0000163 L46.1999823,88.0000164 C59.6458103,87.6370362 73.0574943,86.4628896 86.3618623,84.4839764 C89.8332071,83.99665 92.4115983,81.021062 92.3999823,77.5156964 L92.3999823,74.3789364 L92.3999823,74.3789163 C92.4070022,71.9312667 91.0523723,69.6827963 88.8852447,68.5449563 L88.88528,68.54496 Z M26.4,26.4 C26.4,12.419 33.616,4.4 46.2,4.4 C58.784,4.4 66,12.419 66,26.4 C66,42.51984 56.56288,57.2 46.2,57.2 C35.83712,57.2 26.4,42.51984 26.4,26.4 Z M88,77.51568 L88,77.5156817 C88.0168757,78.8270621 87.0550472,79.9459865 85.756,80.1262017 L85.7559961,80.1262023 C72.6525761,82.0790411 59.4432041,83.2390835 46.1999961,83.6000023 L46.1999907,83.6000021 C32.9567387,83.2383547 19.7473667,82.0775757 6.64399065,80.1240021 L6.6439905,80.1240021 C5.3457881,79.9438877 4.3842385,78.8262265 4.3999993,77.5156821 L4.3999993,74.3648421 L4.39999924,74.3648338 C4.39435976,73.5552206 4.8386326,72.809403 5.55324804,72.4288382 C21.464528,64.0221982 31.501368,59.3124382 35.584568,57.7816782 L35.5845691,57.781679 C38.6114347,60.1789882 42.3396251,61.5199982 46.2000091,61.6000034 L46.2000101,61.6000034 C50.0325201,61.5221612 53.7356701,60.199545 56.7503301,57.8318434 C61.0121701,59.4356434 71.0195301,64.1427634 86.8406101,72.4398434 L86.8406103,72.4398435 C87.5575067,72.818793 88.0041947,73.5649631 87.9995703,74.3758435 L88,77.51568 Z"
                    id="Shape"
                    fill="#000000"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      )

    case 'onboarding-property':
      return (
        <svg style={iconStyle} width="108px" height="95px" viewBox="0 0 108 95" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="linearGradient-1">
              <stop stopColor="#FED766" offset="0%" />
              <stop stopColor="#FF0734" offset="35.3910766%" />
              <stop stopColor="#048FF2" offset="68.3842124%" />
              <stop stopColor="#33CC75" offset="100%" />
            </linearGradient>
          </defs>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-66.000000, -49.000000)">
              <g>
                <rect fill="#BD10E0" opacity="0" x="0" y="0" width="240" height="192" />
                <g opacity="0.900000036" transform="translate(66.000000, 49.000000)" fillRule="nonzero">
                  <path
                    d="M77.76,26.8590909 L77.76,75.5681818 C77.76,76.7606132 76.7929334,77.7272727 75.6,77.7272727 L17.28,77.7272727 L17.28,88.5227273 L17.28,88.5227276 C17.2800002,89.715159 18.2470666,90.6818185 19.44,90.6818185 L88.56,90.6818185 C89.7529333,90.6818186 90.7199999,89.715159 90.7199999,88.5227276 L90.7199999,38.8636367 L90.8621279,38.8636367 L77.76,26.8590909 Z"
                    id="Shape"
                    fill="url(#linearGradient-1)"
                    opacity="0.149999991"
                  />
                  <path
                    d="M107.299728,48.0661136 L55.459728,0.566113636 C54.6330701,-0.188717445 53.36693,-0.188717445 52.5402721,0.56611358 L0.700272061,48.0661136 L0.700272206,48.0661134 C-0.179279794,48.8719596 -0.238753234,50.237943 0.567431774,51.1171248 C1.37361721,51.9963066 2.74017577,52.055755 3.61972777,51.2499093 L12.9599998,42.6917048 L12.9599998,88.5227275 L12.9599998,88.5227285 C12.9600003,92.1000269 15.8611951,95.0000012 19.4399998,95.0000012 L88.5599998,95.0000012 L88.5600001,95.0000012 C92.1388047,95.0000005 95.0400001,92.1000269 95.0400001,88.5227285 L95.0400001,42.6938649 L104.37984,51.2499103 L104.37984,51.2499104 C105.259392,52.0557566 106.625951,51.9963082 107.432136,51.1171259 C108.238322,50.2379441 108.178848,48.8719607 107.299296,48.0661146 L107.299728,48.0661136 Z M90.72,38.8636364 L90.72,88.5227273 C90.72,89.7151586 89.7529334,90.6818182 88.56,90.6818182 L19.44,90.6818182 C18.2470665,90.6818181 17.2799999,89.7151586 17.2799999,88.5227273 C17.2799999,88.5227273 17.2799999,88.5227273 17.2799999,88.5227273 L17.2799999,38.8636364 L17.1374399,38.8636364 L53.9999999,5.08681818 L90.8625599,38.8636364 L90.72,38.8636364 Z"
                    id="Shape"
                    fill="#000000"
                  />
                  <path
                    d="M38.10456,56.6372727 C37.1876702,55.8733993 35.824883,55.9971325 35.060688,56.9136363 C34.2964929,57.8301402 34.4202782,59.1923538 35.337168,59.9562273 C35.337168,59.9562273 35.337168,59.9562273 35.337168,59.9562273 L48.297168,68.5925909 L48.2971682,68.592591 C49.1557682,69.3076085 50.4182234,69.2499219 51.2079842,68.4595906 L72.8079842,46.8686815 C73.6367287,46.0109782 73.6129644,44.6441226 72.7548992,43.8157269 C71.9178474,43.007618 70.5907952,43.007618 69.7537434,43.8157271 L49.5482394,64.0127271 L38.10456,56.6372727 Z"
                    id="Shape"
                    fill="#000000"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      )

    case 'image-icon':
      return (
        <svg
          style={iconStyle}
          width="48px"
          height="48px"
          viewBox="0 0 48 48"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-376.000000, -352.000000)" fill="#000000" fillRule="nonzero">
              <g transform="translate(376.000000, 352.000000)">
                <path
                  d="M44.8695652,0 L3.13043478,0 L3.13043464,0 C1.40154351,7.55722432e-08 -1.37690904e-07,1.40154365 -1.37690904e-07,3.13043478 C-1.37690904e-07,3.13043478 -1.37690904e-07,3.13043478 -1.37690904e-07,3.13043478 L-1.37690904e-07,44.8695652 L-1.37690867e-07,44.8695656 C1.23364437e-07,46.5984567 1.40154351,48.0000003 3.13043464,48.0000003 L44.8695651,48.0000003 C46.5984561,48.0000002 47.9999998,46.5984567 47.9999998,44.8695656 L47.9999998,3.13043512 C47.9999998,1.40154399 46.5984561,3.35847663e-07 44.869565,3.35847663e-07 L44.8695652,0 Z M2.08695652,33.8504348 L13.5337043,23.3586783 L25.3492174,35.1731478 C25.7637412,35.5735075 26.424336,35.5620271 26.8246957,35.1475029 C27.2152508,34.74313 27.2152508,34.102042 26.8246956,33.6976692 L20.7896348,27.6623996 L32.3161043,17.0971822 L45.9130435,30.6928692 L45.9130435,37.565217 L2.08695651,37.565217 L2.08695652,33.8504348 Z M3.13043478,2.08695652 L44.8695652,2.08695652 C45.4458615,2.0869565 45.9130434,2.55413843 45.9130434,3.13043478 L45.9130434,27.741913 L33.0855652,14.9144348 C32.6902915,14.5196703 32.054231,14.5062386 31.6426435,14.8839653 L19.3133217,26.1858783 L14.3029565,21.1753044 C13.907232,20.7815979 13.2720271,20.7681851 12.8600348,21.1448348 L2.0869565,31.0201044 L2.0869565,3.13043481 L2.0869565,3.13043496 C2.08695641,2.55413862 2.55413841,2.0869567 3.13043476,2.0869567 L3.13043478,2.08695652 Z M44.8695652,45.9130435 L3.13043478,45.9130435 C2.55413839,45.9130435 2.08695648,45.4458616 2.08695648,44.8695652 C2.08695648,44.8695652 2.08695648,44.8695652 2.08695648,44.8695652 L2.08695648,39.6521739 L45.9130434,39.6521739 L45.9130434,44.8695652 C45.9130434,45.4458616 45.4458615,45.9130435 44.8695652,45.9130435 Z"
                  id="Shape"
                />
              </g>
            </g>
          </g>
        </svg>
      )

    case 'water-drop':
      return (
        <svg
          style={iconStyle}
          width="18px"
          height="24px"
          viewBox="0 0 18 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            stroke="none"
            strokeWidth="1"
            fill={iconStyle.fontColor ? iconStyle.fontColor : '#303C42'}
            fillRule="evenodd"
          >
            <g transform="translate(-355.000000, -808.000000)" fillRule="nonzero">
              <g transform="translate(355.000000, 808.000000)">
                <path
                  d="M9.335,0.129517 C9.145547,-0.043335 8.854531,-0.043335 8.665078,0.129517 C8.310586,0.449341 3.8e-05,8.045537 3.8e-05,15.000117 C3.8e-05,19.962517 4.037148,24.000117 9.000038,24.000117 C13.962928,24.000117 18.000038,19.962517 18.000038,15.000117 C18.000038,8.045527 9.689488,0.449317 9.334998,0.129517 L9.335,0.129517 Z M9.000039,21.000117 C5.691449,21.000117 3.000039,18.308707 3.000039,15.000117 C3.000039,14.72375 3.223672,14.500117 3.500039,14.500117 C3.776406,14.500117 4.000039,14.72375 4.000039,15.000117 C4.000039,17.756957 6.243199,20.000117 9.000039,20.000117 C9.276406,20.000117 9.500039,20.22375 9.500039,20.500117 C9.500039,20.776484 9.276406,21.000117 9.000039,21.000117 Z"
                  id="Shape"
                />
              </g>
            </g>
          </g>
        </svg>
      )

    case 'search-icon':
      return (
        <svg style={iconStyle} viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.800000012">
            <g transform="translate(-8.000000, -8.000000)" fill="#000000" fillRule="nonzero">
              <g transform="translate(8.000000, 8.000000)">
                <path
                  d="M15.7870012,14.7585455 L11.6595701,10.6310909 C12.5553832,9.51127273 13.0908347,8.09090909 13.0908347,6.54545455 C13.0908347,2.93054545 10.1604877,0 6.54541736,0 C2.9305288,0 0,2.93054545 0,6.54545455 C0,10.1603636 2.9305288,13.0909091 6.54541736,13.0909091 C8.09086312,13.0909091 9.51121869,12.5552727 10.6310305,11.6594545 L14.7584616,15.7869091 C14.9004608,15.9289091 15.0866416,16 15.2726405,16 C15.4588213,16 15.645002,15.9289091 15.7870012,15.7869091 C16.0709996,15.5030909 16.0709996,15.0423636 15.7870012,14.7585455 Z M6.54541736,11.6363636 C3.73379697,11.6363636 1.45453719,9.35709091 1.45453719,6.54545455 C1.45453719,3.73381818 3.73379697,1.45454545 6.54541736,1.45454545 C9.35721956,1.45454545 11.6362975,3.73381818 11.6362975,6.54545455 C11.6362975,9.35709091 9.35721956,11.6363636 6.54541736,11.6363636 Z"
                  id="Shape"
                />
              </g>
            </g>
          </g>
        </svg>
      )

    case 'no-content-graphic':
      return (
        <svg width="272px" height="136px" viewBox="0 0 272 136" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <rect id="path-1" x="0" y="0" width="300" height="225" />
            <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="linearGradient-3">
              <stop stopColor="#FED766" offset="0%" />
              <stop stopColor="#FF0734" offset="34.5624097%" />
              <stop stopColor="#048FF2" offset="65.4308165%" />
              <stop stopColor="#33CC75" offset="100%" />
            </linearGradient>
            <filter x="-23.7%" y="-23.7%" width="147.4%" height="147.4%" filterUnits="objectBoundingBox" id="filter-4">
              <feGaussianBlur stdDeviation="10" in="SourceGraphic" />
            </filter>
          </defs>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-704.000000, -297.000000)">
              <g transform="translate(440.000000, 208.000000)">
                <g transform="translate(250.000000, 0.000000)">
                  <mask id="mask-2" fill="white">
                    <use xlinkHref="#path-1" />
                  </mask>
                  <g id="Mask" />
                  <g mask="url(#mask-2)" id="Oval" stroke="url(#linearGradient-3)">
                    <g transform="translate(42.000000, 117.000000)">
                      <ellipse
                        strokeWidth="15.5001593"
                        transform="translate(108.010083, 108.003397) rotate(360.000000) translate(-108.010083, -108.003397) "
                        cx="108.010083"
                        cy="108.003397"
                        rx="100.202032"
                        ry="100.195347"
                      />
                      <ellipse
                        strokeWidth="31.0003186"
                        opacity="0.300000012"
                        transform="translate(108.066933, 108.086686) rotate(360.000000) translate(-108.066933, -108.086686) "
                        cx="108.066933"
                        cy="108.086686"
                        rx="95.950991"
                        ry="95.9707436"
                      />
                      <ellipse
                        strokeWidth="31.0003186"
                        opacity="0.300000012"
                        filter="url(#filter-4)"
                        transform="translate(108.066933, 108.086686) rotate(360.000000) translate(-108.066933, -108.086686) "
                        cx="108.066933"
                        cy="108.086686"
                        rx="95.950991"
                        ry="95.9707436"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
    default:
      return null
  }
}

const Svg: FC<TProps> = props => {
  const classes = [styles[props.name]]
  if (props.styleNames) {
    classes.push(props.styleNames)
  }

  if (props.align) {
    classes.push(styles[`align-${props.align}`])
  }

  const iconStyle = Object.assign({}, props.style, {
    width: props.width ? props.width : props.height,
    height: props.height,
  })

  const svg = getCustomSvg(props.name, props.styleNames, iconStyle)

  return (
    <span className={classes.join(' ')} style={props.rootStyle} onClick={props.onClick} {...props}>
      {svg}
    </span>
  )
}

export default Svg
